// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__n1-Jy","icon":"SortAdornment_icon__2x3xk","up":"SortAdornment_up__3FV0M","down":"SortAdornment_down__3Cy38","active":"SortAdornment_active__3yTQN"};